import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=c0c833ca&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=c0c833ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c833ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0c833ca')) {
      api.createRecord('c0c833ca', component.options)
    } else {
      api.reload('c0c833ca', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=c0c833ca&scoped=true", function () {
      api.rerender('c0c833ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/Admin.vue"
export default component.exports